import React from 'react';

import { Button } from '../ui/catalyst/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';

interface FormActionsProps {
  handleCancel: () => void;
  isLoading: boolean;
  isValid: boolean;
  submitLabel?: string;
  isUpdateMode?: boolean;
  disabled?: boolean;
  disabledReason?: string;
}

export const FormActions: React.FC<FormActionsProps> = ({
  handleCancel,
  isLoading,
  isValid,
  submitLabel = 'Create Matter',
  isUpdateMode = false,
  disabled = false,
  disabledReason,
}) => {
  const isButtonDisabled = !isValid || isLoading || disabled;
  const showTooltip = disabled && disabledReason;

  const submitButton = (
    <Button
      type="submit"
      color="indigo"
      disabled={isButtonDisabled}
    >
      {isLoading ? (isUpdateMode ? 'Saving...' : 'Creating...') : submitLabel}
    </Button>
  );

  return (
    <div className="flex justify-end gap-4">
      <Button type="button" onClick={handleCancel} outline disabled={isLoading}>
        Cancel
      </Button>
      {showTooltip ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="inline-block">{submitButton}</span>
            </TooltipTrigger>
            <TooltipContent>
              <p>{disabledReason}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        submitButton
      )}
    </div>
  );
};
